import Backdraft from "backdraft-app/src/backdraft";
import _ from "underscore";

import KeywordsEditor from "shared/keywords_form/views/editor";
import KeywordsCriteria from "shared/keywords_form/views/criteria";

import Select from "shared/select";

Backdraft.app("Shared/ExpressionBuilder", function(app) {
  app.view("VoiceForm", {
    template: _.template(`
      <div class="row form-group">
        <div class="keywords-editor col-{{= isModal ? 12 : 9 }}"></div>
      </div>
      <div class="row form-group">
        <div class="keywords-criteria col-{{= isModal ? 12 : 9 }}"></div>
      </div>
    `),

    initialize: function(options) {
      this.isModal = options.isModal;
      this.editable = _.isUndefined(options.editable) ? true : options.editable;

      this.child("keywordsEditor", new KeywordsEditor({ collection: this.model.keywords, editable: this.editable }));
      this.child("keywordsCriteria", new KeywordsCriteria({ model: this.model, editable: this.editable }));
    },

    render: function() {
      this.$el.html(this.template({ isModal: this.isModal }));
      this.$('.keywords-editor').html(this.child("keywordsEditor").render().$el);
      this.$('.keywords-criteria').html(this.child("keywordsCriteria").render().$el);

      Select.convertAll(this.$el);
      this._restoreUIState();
      return this;
    },

    _restoreUIState: function() {
      // trigger all changes to allow the UI components to adjust since they are inter-connected
      this.model.triggerChanges();
    }
  });
});
